import { render, staticRenderFns } from "./AiSearch.vue?vue&type=template&id=1a6a9657&scoped=true"
import script from "./AiSearch.vue?vue&type=script&lang=js"
export * from "./AiSearch.vue?vue&type=script&lang=js"
import style0 from "./AiSearch.vue?vue&type=style&index=0&id=1a6a9657&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6a9657",
  null
  
)

export default component.exports